<script>
import UebungenLibraryIndex from "@/uebungen-library/components/UebungenLibraryIndex.vue";
import UebungenLibraryCreateUebung from "./UebungenLibraryCreateUebung.vue";
import {EventBus} from "@js/hermeneus.eventbus/eventbus.js";
export default {
  name: "uebungen-library-dashboard",
  components: {UebungenLibraryCreateUebung, UebungenLibraryIndex},
  data () {
    return {
    };
  },
  methods: {
    openCreateUebungComponentEvent () {
      this.$emit("uebungen-library__set-active-step", "create-uebung");
    },
    openModal (event) {
      // Hole die Position des Buttons
      const button = event.currentTarget;
      const rect = button.getBoundingClientRect();

      // Berechne den Mittelpunkt des Buttons
      const position = {
        x: rect.left + (rect.width / 2),
        y: rect.top + (rect.height / 2)
      };

      // Sende Event an die übergeordnete Komponente mit korrekter Position
      EventBus.$emit('uebungen-library__open-create-modal', {
        position: position
      });
    }
  },
}
</script>

<template>
  <div class="uebungen-library__dashboard flex flex-col">
    <div class="flex flex-row justify-end  p-5 ">


      <button v-if="this.$userData.role === 'admin'" @click="openModal" class="uebungen-library__btn-create-uebung w-[6rem] h-[6rem] text-5xl text-white rounded-xl">
        <hermeneus-icon name="hi-uebung-create" color="current" height="68" width="68" class="z-[1000]"></hermeneus-icon>
      </button>
    </div>
    <!--    <h1>UebungenLibrary__Dashboard</h1>-->
    <div class="flex flex-row ">
      <div class="w-1/2 bg-primary-200">
        <!--        <h1>UebungenLibrary__Dashboard__Neuigkeiten</h1>-->
      </div>
      <div class="w-1/2 bg-primary-200">
        <!--        <h1>UebungenLibrary__Dashboard__Übungsvorschläge</h1>-->
      </div>
    </div>
    <div>
      <uebungen-library-index class="rounded"></uebungen-library-index>
    </div>
  </div>
</template>

<style scoped>
.uebungen-library__btn-create-uebung {
  background-color: theme('colors.primary-800');
  /* background-image: linear-gradient(
      45deg,
      hsl(232deg 23% 13%) 0%,
      hsl(232deg 22% 15%) 12%,
      hsl(231deg 21% 18%) 24%,
      hsl(231deg 19% 20%) 36%,
      hsl(230deg 18% 22%) 48%,
      hsl(230deg 16% 24%) 60%,
      hsl(229deg 15% 27%) 72%,
      hsl(228deg 14% 29%) 84%,
      hsl(228deg 13% 31%) 100%
  ); */
  transition: all 0.3s ease;
}

.uebungen-library__btn-create-uebung:hover {
  background-color: theme('colors.primary-700');
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.button-clicked {
  animation: button-pulse 0.3s ease-in-out;
}

@keyframes button-pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
</style>